module.exports = __webpack_public_path__ + "static/media/pantry@3x.19c895d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pantry@3x.png
// module id = 781
// module chunks = 1